module.exports = __webpack_public_path__ + "static/media/Kit_Extra_BG_2.a3a72507.png";